class HlsSafe {
  static Events = {
    MANIFEST_PARSED: "manifestParsed",
    ERROR: "error",
  };

  static ErrorTypes = {
    NETWORK_ERROR: "networkError",
    MEDIA_ERROR: "mediaError",
  };

  static isSupported() {
    return false;
  }

  loadSource() {}
  attachMedia() {}
  on() {}
  startLoad() {}
  recoverMediaError() {}
  destroy() {}
}

export default HlsSafe;

